import { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { useBroadcast } from '../../hooks/useBroadcast';
import { useGetParams } from '../../hooks/useGetParams';
import { hideNumber } from '../../helpers/titreHelper';

import styles from './Winner.module.css';
import hum from '../../assets/images/hum.png';
import starSmall from '../../assets/images/starSmall.png';
import starBig from '../../assets/images/starBig.png';
import confetti from '../../assets/images/confetti.gif';

function Winner() {
  const { winnerFontSize, winnerWord } = useGetParams();
  const { currentMessage } = useBroadcast();

  const confettiRef = useRef(null);

  const errorHandler = (e) => {
    e.target.src = hum;
  };

  useEffect(() => {
    let idTimeout = '';

    if (currentMessage) {
      idTimeout = setTimeout(() => {
        confettiRef.current.style.display = 'block';
      }, 500);
    }

    return () => {
      clearTimeout(idTimeout);
    };
  }, [confettiRef, currentMessage]);

  return (
    <AnimatePresence mode="wait">
      {currentMessage && (
        <motion.div
          key={currentMessage.id}
          exit={{ opacity: 0 }}
          style={{ height: '100%' }}
        >
          <div
            className={styles.winnerWrapper}
            key={currentMessage?.message.author}
          >
            <motion.div
              initial={{ y: '-70vh', opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1, delay: 0.4 }}
              className={styles.wordWinner}
            >
              {winnerWord}
            </motion.div>

            <div className={styles.starsBlock}>
              <motion.img
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.72, delay: 0.5 }}
                src={starSmall}
                alt="starSmall"
                className={styles.starSmall}
              />
              <motion.img
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.72, delay: 0.24 + 0.5 }}
                src={starBig}
                alt="starBig"
                className={styles.starBig}
              />
              <motion.img
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ duration: 0.72, delay: 0.48 + 0.5 }}
                src={starSmall}
                alt="starSmall"
                className={styles.starSmall}
              />
            </div>
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1, delay: 0 }}
              className={styles.imgBlock}
            >
              <img
                src={
                  (currentMessage?.message.image &&
                    currentMessage?.message.image !== '1' &&
                    currentMessage?.message.image) ||
                  hum
                }
                alt="Фото"
                onError={errorHandler}
              />

              <svg
                width="200"
                height="200"
                viewBox="0 0 200 200"
                className={styles.circleBorder}
              >
                <defs>
                  <linearGradient
                    id="shadowGrad"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="0%"
                  >
                    <stop offset="0%" stopColor="#00B3FF" />
                    <stop offset="100%" stopColor="#ffffff" />
                  </linearGradient>

                  <filter
                    id="shadow"
                    x="-20%"
                    y="-20%"
                    width="140%"
                    height="140%"
                  >
                    <feDropShadow
                      dx="0"
                      dy="0"
                      stdDeviation="8"
                      floodColor="#FFFFFF"
                      floodOpacity="1"
                    />
                  </filter>
                </defs>

                <circle
                  cx="100"
                  cy="100"
                  r="80"
                  fill="none"
                  stroke="url(#shadowGrad)"
                  strokeWidth="2"
                  filter="url(#shadow)"
                />
              </svg>

              <svg
                width="200"
                height="200"
                viewBox="0 0 200 200"
                className={styles.circleSmallBorder}
              >
                <defs>
                  <linearGradient
                    id="shadowGrad1"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="0%"
                  >
                    <stop offset="0%" stopColor="#ffffff" />
                    <stop offset="100%" stopColor="#00B3FF" />
                  </linearGradient>

                  <filter
                    id="shadow1"
                    x="-20%"
                    y="-20%"
                    width="140%"
                    height="140%"
                  >
                    <feDropShadow
                      dx="0"
                      dy="0"
                      stdDeviation="8"
                      floodColor="#FFFFFF"
                      floodOpacity="1"
                    />
                  </filter>
                </defs>

                <circle
                  cx="100"
                  cy="100"
                  r="90"
                  fill="none"
                  stroke="url(#shadowGrad1)"
                  strokeWidth="2"
                  filter="url(#shadow1)"
                />
              </svg>
            </motion.div>

            <motion.div
              initial={{ y: '70vw', opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                duration: 1,
                delay: 0.4,
              }}
              className={styles.winnerName}
              style={{
                fontSize: `${winnerFontSize}rem`,
              }}
            >
              <div>
                {currentMessage?.message?.author ||
                  hideNumber(currentMessage?.message?.senderNumber)}
              </div>
            </motion.div>

            <img
              src={confetti}
              alt="confetti"
              className={styles.confetti}
              ref={confettiRef}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default Winner;
